import { apiRoutes } from 'config/apiRoutes'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useAxiosPrivate } from 'shared/hooks'
import type { AreaRes } from 'features/areas'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'

export const useFetchArea = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)

	const { data: booth, isSuccess: isAreaSuccess } = useQuery<AreaRes>({
		queryKey: queryKeys.booths.detail(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.area(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		booth,
		isAreaSuccess
	}
}
